import React from 'react'
import { useHistory } from 'react-router-dom'
import styled from '@emotion/styled/macro'
import QueryAccount from 'components/QueryAccount'
import useDarkMode from 'use-dark-mode'
import mq from 'mediaQuery'
import CheckMarkIcon from 'assets/checkmarkicon'
import FavoritesIcon from 'assets/Favorite'

const FavoriteList = ({ data }) => {
  const history = useHistory()
  const darkMode = useDarkMode()
  const isDark = darkMode.value

  const onRedirect = domainName => {
    const name = domainName.split('.')
    history.push(`/search/${name[0]}`)
  }

  return (
    <QueryAccount>
      {({ account }) => {
        if (account === '0') {
          return (
            <H5Bold style={{ color: '#E7303C' }}>
              {data?.connectMetamaskText}
            </H5Bold>
          )
        }

        const favorites = localStorage.getItem(`favorite_ans_${account}`)

        if (!favorites)
          return <H5Bold isDark={isDark}>{data?.noFavoritesText}</H5Bold>
        else {
          const lists = favorites.split(',')
          return (
            <div>
              {lists.map((list, id) => (
                <Wrap key={id} isDark={isDark} onClick={() => onRedirect(list)}>
                  <Flex>
                    <CheckMarkIcon />
                    <H5Bold isDark={isDark}>{list}</H5Bold>
                  </Flex>
                  <FavoritesIcon isFavorite />
                </Wrap>
              ))}
            </div>
          )
        }
      }}
    </QueryAccount>
  )
}

export default FavoriteList

const Flex = styled('div')`
  display: flex;
  align-items: center;
  max-width: 160px;

  ${mq.medium`
    max-width: inherit;
    width: auto;
  `}

  svg {
    margin-right: 5px;
    width: 20px;
    height: 20px;

    ${mq.medium`
      margin-right: 10px;
      width: 24px;
      height: 24px;
    `}
  }
`

const Wrap = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: -1px;
  padding: 24px;
  background: ${({ isDark }) => (isDark ? '#282828' : '#fff')};
  border: ${({ isDark }) =>
    isDark ? '0.5px solid #181818' : '0.5px solid #000000'};
  cursor: pointer;
`

const H5Bold = styled('div')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 133.4%;
  text-align: center;
  color: ${({ isDark }) => (isDark ? '#fff' : '#181818')};
  text-overflow: ellipsis;
  overflow: hidden;
  ${mq.medium`
  font-weight: 700;
  font-size: 24px;
  `}
`
